/**
 * Kalendersidans två sektioner. Sektionen styrs uteslutande av sidomenyn via ?section= -
 * både sidomenyn och kalendersidan läser parametern, ingen av dem äger ett eget state.
 */
export type CalendarSection = 'absence' | 'bookings';

/** Allt utom den exakta strängen 'bookings' tolkas som frånvaro, så trasiga länkar landar rätt. */
export const parseCalendarSection = (value: string | null | undefined): CalendarSection => (value === 'bookings' ? 'bookings' : 'absence');
